// src/components/Navbar.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import logo from '../Images/logo.png';





const CustomNavbar = () => {

  const location = useLocation();  // Get the current route
  
  // Function to determine the background color based on the current route
  const getNavbarBgColor = () => {
    switch (location.pathname) {
      case '/':
        return '#f8f8f8';  // Red for Page 1
      case '/about':
        return '#f7f7f7';  // Blue for Page 2
      case '/services':
        return '#f6f6f6';  // Green for Page 3
      case '/infrastructure':
        return '#f5f5f5';  // Pink for Page 4
      case '/quality':
        return '#f4f4f4';  // Yellow for Page 5
      case '/contact':
        return '#f3f3f3'
      default:
        return '#f8f8f8';     // Default background color
    }

  }
  const [expanded, setExpanded] = useState(false);

  const toggleNavbar = () => setExpanded(!expanded);

  return (
    <div className="sidebar">
      <Navbar expanded={expanded} style={{ backgroundColor: getNavbarBgColor(),}} variant="dark" expand="lg" fixed="top" className="flex-column sidebar-section">
        <Navbar.Brand as={Link} to="/" className="text-center">
          <img
            src={logo}
            alt="Logo"
            width="150"
            className="img-fluid"
          />
        </Navbar.Brand>

        <Navbar.Toggle onClick={toggleNavbar} />
        <Navbar.Collapse>
          <Nav className="flex-column">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/about">About Us</Nav.Link>
            <Nav.Link as={Link} to="/services">Services</Nav.Link>
            <Nav.Link as={Link} to="/infrastructure">Infrastructure</Nav.Link>
            <Nav.Link as={Link} to="/quality">Quality</Nav.Link>
            <Nav.Link as={Link} to="/contact">Contact Us</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}

export default CustomNavbar;
